// extracted by mini-css-extract-plugin
export default {"cardBody":"submission_card__cardBody__0m8D8","statusPill":"submission_card__statusPill___XN_u"};